/* global ClipboardJS */

export default function( $ ) {
	var $body = $( 'body' );

	const clipboard = new ClipboardJS( '.-copy' );
	clipboard.on( 'success', e => {
		$( e.trigger ).addClass( 'copied' );
	} );

	$( '[data-open]' ).click( function() {
		window.location.replace( $( this ).data( 'open' ) );
	} );

	$( '[data-toggle]' ).click( function() {
		$( this ).toggleClass( 'is-on' );
		$( this ).parents( '.screen' ).toggleClass( $( this ).data( 'toggle' ), $( this ).hasClass( 'is-on' ) );
	} );

	$( '.screen' ).on( 'showing', function() {
		$( this ).find( '.screen-inner' ).scrollTop( 0 );
	} );

	$( '.modal' ).on( 'click', '.button-close', function() {
		$( this ).parents( '.modal' ).hideView();
	} );

	$( 'form.modal' ).on( 'reset', () => {
		$body.addClass( 'navigating-back' );
		history.back();
	} );

	$( '.-print' ).click( () => window.print() );

	$( '.-clear' ).click( function() {
		$( this ).parent().find( 'input' ).val( null ).trigger( 'input' ).focus();
	} );

	var $backdrops = $( '.backdrop' );

	function pickBackdrop() {
		return Math.floor( Math.random() * 8 );
	}

	var current;
	function roateBackdrops() {
		var next;

		if ( $( '.modal.in' ).length > 0 ) {
			return;
		}

		do {
			next = pickBackdrop();
		} while ( next === current );

		$backdrops.removeClass( 'in' ).eq( next ).addClass( 'in' );
		current = next;
	}

	setInterval( roateBackdrops, 2000 );
	roateBackdrops();
}
